import React from "react"
import { graphql, PageProps } from "gatsby"

import Layout from "../components/layout"
import { Form, Description } from "../components/contact"
import { ContactQuery } from "./__generated__/ContactQuery"

export default ({ data, location }: PageProps<ContactQuery>) => {
    const api_url = data.site.siteMetadata.contact.api_url
    const hasContactForm = api_url
    return (
        <Layout
            seo={{
                title:
                    "Kontakt do fizjoterapuety koni. Wojewózdztwo Mazowieckie",
            }}
            location={location}
        >
            <div className="large-container">
                <header className="pt-20 pb-12 lg:pt-32 lg:pb-16 text-center">
                    <p className="eyebrow">Zapraszam do kontaktu</p>
                    <h1 className="display-2 text-color-1 mt-5">Kontakt</h1>
                    <div className="rule-short mt-10 mx-auto"></div>
                </header>

                <div className="lg:flex lg:justify-between pb-24 lg:pb-32">
                    <div className="lg:w-1/2 lg:pr-16">
                        <Description data={data.site.siteMetadata.contact} />
                    </div>
                    <div className="lg:w-1/2 mt-16 lg:mt-0">
                        {hasContactForm ? (
                            <Form api={api_url} />
                        ) : (
                            <div className="frame">
                                <img
                                    src="/images/main1.jpeg"
                                    alt="Fizjoterapia koni"
                                    className="w-full"
                                    style={{
                                        height: "30rem",
                                        objectFit: "cover",
                                    }}
                                    loading="lazy"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export const query = graphql`
    query ContactQuery {
        site {
            siteMetadata {
                contact {
                    api_url
                    description
                    mail
                    phone
                }
            }
        }
    }
`
